import React from 'react';
import { Main, Header, Content, CloseIcon } from '../StyledComponents';
import CheckCircle from '@strapi/icons/CheckCircle';
import Cross from '@strapi/icons/Cross';
import { Typography } from '@strapi/design-system/Typography';
import styles from '../AccessibilityChecker.module.css';
import { NO_ISSUES_BODY, NO_ISSUES_HEADER, NO_ISSUES_TITLE } from '../../../utils/constants';
export const NoIssues = ({
  onClose
}) => {
  return /*#__PURE__*/React.createElement(Main, null, /*#__PURE__*/React.createElement(Header, {
    background: "success600",
    color: "neutral0"
  }, /*#__PURE__*/React.createElement("div", {
    className: `${styles.icon} ${styles['header-title']}`
  }, /*#__PURE__*/React.createElement(CheckCircle, {
    className: styles['title-icon']
  }), /*#__PURE__*/React.createElement(Typography, {
    variant: "omega",
    fontWeight: "bold",
    textColor: "neutral0"
  }, NO_ISSUES_TITLE)), /*#__PURE__*/React.createElement("div", {
    className: styles['actions']
  }, /*#__PURE__*/React.createElement(CloseIcon, {
    background: "success200",
    color: "neutral800",
    onClick: onClose
  }, /*#__PURE__*/React.createElement(Cross, {
    className: `${styles['header-icon-success']} ${styles['header-icon']}`
  })))), /*#__PURE__*/React.createElement(Content, {
    background: "success100",
    borderColor: "success200",
    color: "neutral800"
  }, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(Typography, {
    variant: "omega",
    fontWeight: "bold",
    textColor: "neutral800",
    className: styles['body-title']
  }, NO_ISSUES_HEADER)), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(Typography, {
    fontWeight: "semiBold",
    variant: "omega",
    textColor: "neutral800"
  }, NO_ISSUES_BODY))));
};